import React, { Fragment } from 'react';

import moment from 'moment';
import styled from 'styled-components';

import FieldView from '../utils/FieldView';
import '../../styles/components/FilterPanel.css';
import { getCreatedFrom } from '../../infrastructure/utils/events';
import CollapsableItem from '../utils/CollapsableItem';
import { isMobileResolution } from '../../infrastructure/utils/common';
import { Party } from '../../types/Party';
import { EventParty } from '../../types/Event';
import { Activity } from '../../types/Activity';
import { Member } from '../../types/Member';

import AttendeesView from './AttendeesView';

type Props = {
  event: EventParty;
  name: string;
  dates: string;
  attendees: Member[];
  title: string;
  allMembers: [];
  activity: Activity;
  party: Party;
};

const textStyles = `
  font-size: 30px;
  font-weight: bold;`;

const Title = styled.h1`
  ${textStyles}
`;

const SubTitle = styled.h2`
  ${textStyles}
`;

const FlighType = styled.h2`
  font-size: 18px;
  margin-bottom: 32px;
  color: #4f4f4f;
`;

const MarginDiv = styled.div`
  margin: 20px 0;
  position: relative;
`;

const UnderlineText = styled.div`
  font-size: 18px;
  textdecoration: underline;
`;

const FlightEventView = ({
  event,
  name,
  dates,
  attendees = [],
  title,
  allMembers = [],
  activity,
  party,
}: Props) => {
  const notAvailableLabel = 'n/a';
  const {
    eventLocationFrom,
    eventLocationTo,
    passengers,
    flightType,
    duration,
    costType,
    createdAt,
    startTz = '',
    cost,
    dressCode,
    eventDescription,
    travelType,
  } = event ?? { passengers: { flightNumber: notAvailableLabel } };
  const { flightNumber, locationFrom, locationTo } = passengers ?? {
    flightNumber: notAvailableLabel,
  };
  const { address: fromAddress } = eventLocationFrom ?? {
    address: locationFrom?.address,
  };
  const { address: toAddress } = eventLocationTo ?? {
    address: locationTo?.address,
  };
  return (
    <Fragment>
      <Title>{title}</Title>
      <SubTitle>{name}</SubTitle>
      <div className='event-dates'>
        <i className='fas fa-clock' />
        {dates}
      </div>
      <div className={!isMobileResolution() ? 'data-box' : ''}>
        <FlighType>
          {flightType === 'Arriving' ? 'Arriving' : 'Returning'}
        </FlighType>
        <FieldView name='Flight Number:' md={2} vmd={4}>
          {flightNumber}
        </FieldView>
        <FieldView name='Created From:' md={2} vmd={4}>
          {getCreatedFrom(event, activity, party)}
        </FieldView>
        <FieldView name='From:' md={2} vmd={4}>
          {fromAddress}
        </FieldView>
        {(travelType === undefined || travelType === 'Flight') && (
          <FieldView name='To:' md={2} vmd={4}>
            {toAddress}
          </FieldView>
        )}
        <FieldView name='Duration:' md={2} vmd={4}>
          {duration || notAvailableLabel}
        </FieldView>
        <FieldView name='Budget Type:' md={2} vmd={4}>
          {costType || notAvailableLabel}
        </FieldView>
        <FieldView name='Created At:' md={2} vmd={4}>
          {createdAt
            ? moment(createdAt).tz(startTz).format('MM/DD/YYYY')
            : notAvailableLabel}
        </FieldView>
      </div>
      <MarginDiv className={!isMobileResolution() ? 'data-box' : ''}>
        <UnderlineText>Optional Details:</UnderlineText>
        <CollapsableItem top={isMobileResolution() ? '-31px' : ''}>
          <FieldView name='Est.Budget:' md={2} vmd={4}>
            {cost && costType ? cost : notAvailableLabel}
          </FieldView>
          <FieldView name='Dress Code:' md={2} vmd={4}>
            {dressCode || notAvailableLabel}
          </FieldView>
          <AttendeesView attendees={attendees} allMembers={allMembers} />
          <FieldView name='Additional Notes:' md={2} vmd={4}>
            {eventDescription || notAvailableLabel}
          </FieldView>
        </CollapsableItem>
      </MarginDiv>
    </Fragment>
  );
};

export default FlightEventView;
